import {getToken, getUserInfo, removeToken, removeUserInfo, setToken, setUserInfo} from "@/utils/auth";
import {userPhoneLogin} from "@/api/login";
import {getProfile, userLoginOut} from "@/api/user/userInfo";
import bus from "@/plugins/bus";
import msgModal from "@/plugins/modal"
import router from '@/router' // 直接引入路由实例


export default {
    name: 'user',
    // 开启命名空间（必须！模块化核心，避免不同模块的方法）
    namespaced: true,
    state: () => ({
        userInfo: getUserInfo() || null, // 用户信息
        token: getToken() || '', // 登录token（持久化到本地）
        isLogin: false // 登录状态
    }),
    mutations: {
        // 设置token
        SET_TOKEN(state, token) {

            state.token = token
            state.token = token
            setToken(token)
        },
        // 设置用户信息
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
            state.isLogin = !!userInfo
            setUserInfo(userInfo)
        },
        // 退出登录：清空状态
        LOGOUT(state) {
            state.token = ''
            state.userInfo = null
            state.isLogin = false
            removeToken()
            removeUserInfo()
        }
    },

    actions: {
        //手机号登录
        phoneLogin({commit}, phoneLoginForm) {
            return new Promise((resolve, reject) => {
                userPhoneLogin(phoneLoginForm).then(res => {
                    if (res.code === 200 && res.data.token) {
                        commit('SET_TOKEN', res.data.token)
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error.message)
                })
            })
        },
        //获取用户信息
        async getUserInfo({commit}) {
            console.log('获取用户信息')
            getProfile().then(res => {
                commit('SET_USER_INFO', res.data)
                bus.emit('top:getUserInfo')
            })
        },


        // 退出登录（可同步/异步，示例为同步）
        logout({commit}) {
            userLoginOut().then(res => {
                console.log('退出登录成功:' + res)
                commit('LOGOUT')
                bus.emit('top:getUserInfo')
                msgModal.notice('退出登录成功！', 'success', '系统提示')
                router.push('/')
            })
        }
    },
    // 计算属性：基于state派生新状态（类似组件的computed），缓存结果，依赖变化才重新计算
    getters: {
        // 示例：获取用户昵称，无则返回'游客'
        userName: (state) => state.userInfo?.name || '游客',
        // 示例：判断是否为管理员（模拟）
        isAdmin: (state) => state.userInfo?.role === 'admin' || false
    }
}